import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  FreeMode,
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
} from "swiper";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import CatalogCard from "./CatalogCard";

const CourseSlider = ({ Courses }) => {
  if (Courses === undefined || Courses === null) {
    return (
      <div className="flex gap-4 overflow-hidden">
        {[...Array(3)].map((_, i) => (
          <SkeletonTheme
            key={i}
            baseColor="#AFB2BF"
            highlightColor="#F1F2FF"
          >
            <div>
              <Skeleton className="h-[100px] w-[200px] rounded-xl md:h-[200px] lg:w-[400px]" />
              <Skeleton className="mt-2 h-[20px] w-[70px] rounded-md" />
              <Skeleton className="mt-2 h-[20px] rounded-md md:w-[400px]" />
              <Skeleton className="mt-2 h-[20px] rounded-md md:w-[400px]" />
            </div>
          </SkeletonTheme>
        ))}
      </div>
    );
  }

  if (Courses.length === 0) {
    return (
      <p className="rounded-xl border border-richblack-200 bg-richblack-5 px-4 py-8 text-center text-richblack-600">
        No courses in this section yet.
      </p>
    );
  }

  return (
    <Swiper
      mousewheel={{ enabled: true, forceToAxis: true }}
      keyboard={{ enabled: true, onlyInViewport: true }}
      slidesPerView={1}
      loop={false}
      spaceBetween={20}
      pagination={{ clickable: true }}
      modules={[Pagination, Navigation, FreeMode, Mousewheel, Keyboard]}
      className="catalog-swiper mySwiper md:pt-5"
      freeMode={true}
      navigation={true}
      breakpoints={{
        300: { slidesPerView: 2.1, spaceBetween: 10 },
        640: { slidesPerView: 2.2 },
        1024: { slidesPerView: 3.1 },
      }}
    >
      {Courses.map((course) => (
        <SwiperSlide key={course.id || course.title}>
          <CatalogCard course={course} Height="lg:h-[250px] h-[100px]" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CourseSlider;
